import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  appEnvironment: 'test',
  environmentLabel: 'TEST',
  apiUrl: 'https://ggm-cp-test-app.calmwave-f129c301.spaincentral.azurecontainerapps.io',
  appID: 'F38510D1-5099-4287-9E29-946D52240145',
  cookieDomain: 'localhost',
  brandingDomainOverride: null,
};
